







































import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '@/store/modules/common'
@Component({
  name: 'question',
  components: {}
})
export default class Question extends Vue {
  active = ''

  questionList: any = [
    {
      id: 1,
      title: '如何兑换积分？',
      content: '您好，选择您要兑换的金额，绑定好提现的微信申请提现即可'
    },
    {
      id: 2,
      title: '积分提现钱为什么还不到账?在哪里查看?',
      content:
        '您好，提现是24小时内到账的，国家法定节假日顺延，请注意微信支付的收款记录，如有疑题可以联系mungdax客服'
    },
    {
      id: 3,
      title: '私聊对方主动发消息，为什么回复后没积分?',
      content:
        '可以在积分清单核对一下是否收到积分，聊天界面积分系统显示会有延迟，如有疑题可以联系mungdax客服'
    },
    {
      id: 4,
      title: '提现记录在哪里能看到?',
      content: '您好，可以在积分清单-积分兑换中查看您的提现记录'
    },
    {
      id: 5,
      title: '申请提现的时候微信绑定错了怎么办?',
      content:
        '您好，积分提现目前只支持提现到微信，且不能更改请谨慎绑定您的到账微信，如有其它疑问请联系mungdax客服'
    },
    {
      id: 6,
      title: '提现提示需要认证?',
      content: '在申请积分提现前，您的账号需要实名认证都通过后才能提交申请'
    },
    {
      id: 7,
      title: '为什么申请提现失败?',
      content:
        '有可能审核人员查询到你的积分获取记录有异常，存着刷单行为。一旦发现有该情况，提现申请会失败。并且提现的积分不予退还。'
    }
  ]

  async created() {
    // 获取当前语言
    const data = (this.$route.query.language as string) || 'ug'
    this.getLanguage(data)
    CommonModule.setLanguage(data)
  }

  // 当前语言
  get language() {
    return this.$i18n.locale
  }

  // 切换语言
  getLanguage(language: string) {
    this.$i18n.locale = language
  }

  // 返回
  handelBack() {
    this.$router.back()
  }
}
